{
    "default" : {
        "initial_view" : {
            "admin" : "dashboard",
            "manager" : "dashboard",
            "manager-location" : "dashboard",
            "booking-manager" : "reservations/reservationsList",
            "mediator" : "dashboard",
            "guide" : "reservations/reservationsList",
            "garage-staff" : "tasks",
            "user" : "reservations/orders",
            "support" : "helpdesk"
        },
        "admin" : {
            "dashboard" : true,
            "settings" : true,
            "reservations" : {
                "reservationsList" : true,
                "orders": true,
                "calendar": true
            },
            "reservationsList" : true,
            "orders": true,
            "contingents" : {
                "contingents" : true,
                "products" : true,
                "locations" : true,
                "facilities" : true,
                "pricetariffs" : true,
                "pricediscounts" : true,
                "check_in_periods" : true,
                "abonnements": true
            },
            "resources" : true,
            "users" : {
                "users" : true,
                "staff" : true,
                "groupList" : true,
                "messages" : true,
                "deleteMessages" : true
            },
            "appointments" : true,
            "vouchers" : true,
            "finances" : {
                "transactions" : true,
                "salesBillings" : true,
                "paymentAccounts" : true
            },
            "statistics": true,
            "my-inbooma" : true,
            "tasks" : true,
            "filemanager" : true,
            "visual_inspections": true
        },
        "support" : {
            "helpdesk" : true,
            "dashboard" : false,
            "settings" : false,
            "reservations" : {
                "reservationsList" : false,
                "orders": false,
                "calendar": false
            },
            "reservationsList" : false,
            "orders": false,
            "contingents" : {
                "contingents" : false,
                "products" : false,
                "locations" : false,
                "facilities" : false,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : false
            },
            "resources" : false,
            "users" : {
                "users" : false,
                "staff" : false,
                "groupList" : false,
                "messages" : false,
                "deleteMessages" : false
            },
            "appointments" : false,
            "vouchers" : false,
            "finances" : {
                "transactions" : false,
                "salesBillings" : false,
                "paymentAccounts" : false
            },
            "statistics": false,
            "my-inbooma" : false,
            "tasks" : false,
            "filemanager" : false,
            "visual_inspections": false
        },
        "manager" : {
            "dashboard" : true,
            "settings" : true,
            "reservations" : {
                "reservationsList" : true,
                "orders": true,
                "calendar": true
            },
            "reservationsList" : true,
            "orders": true,
            "contingents" : {
                "contingents" : true,
                "products" : true,
                "locations" : true,
                "facilities" : true,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : true,
                "abonnements": true
            },
            "resources" : true,
            "users" : {
                "users" : true,
                "staff" : true,
                "groupList" : true,
                "messages" : true,
                "deleteMessages" : true
            },
            "appointments" : false,
            "vouchers" : true,
            "finances" : {
                "transactions" : true,
                "salesBillings" : true,
                "paymentAccounts" : false
            },
            "statistics": true,
            "my-inbooma" : true,
            "tasks" : true,
            "filemanager" : true,
            "visual_inspections": true
        },
        "manager-location" : {
            "dashboard" : true,
            "orders" : true,
            "reservationsList": true,
            "reservations" : {
                "calendar": true,
                "reservationsList": true
            },

            "contingents" : {
                "contingents" : true,
                "products" : true,
                "locations" : true,
                "facilities" : false,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : true
            },
            "resources" : true,
            "users" : {
                "users" : true,
                "staff" : false,
                "groupList" : true,
                "messages": false
            },
            "appointments" : true,
            "vouchers" : false,
            "finances" : {
                "transactions" : true,
                "salesBillings" : true,
                "paymentAccounts" : false
            },
            "statistics": true,
            "my-inbooma" : true,
            "tasks" : true,
            "filemanager" : true,
            "visual_inspections": false
        },
        "booking-manager" : {
            "dashboard" : true,
            "reservations" : {
                "reservationsList" : true,
                "orders": true,
                "calendar": true
            },
            "reservationsList" : true,
            "orders": true,
            "contingents" : {
                "contingents" : false,
                "products" : false,
                "locations" : false,
                "facilities" : false,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : true
            },
            "resources" : true,
            "users" : {
                "users" : true,
                "staff" : true,
                "groupList": false,
                "messages": false
            },
            "appointments" : false,
            "vouchers" : false,
            "finances" : {
                "transactions" : false,
                "salesBillings" : true,
                "paymentAccounts" : false
            },
            "statistics": true,
            "my-inbooma" : true,
            "tasks" : true,
            "filemanager" : true,
            "visual_inspections": false
        },
        "mediator" : {
            "dashboard" : true,
            "reservations" : {
                "reservationsList" : true,
                "orders": true,
                "calendar": true
            },
            "reservationsList" : true,
            "orders": true,
            "contingents" : {
                "contingents" : false,
                "products" : false,
                "locations" : false,
                "facilities" : false,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : false
            },
            "resources" : true,
            "users" : {
                "users" : true,
                "staff" : false,
                "groupList": false,
                "messages": false
            },
            "appointments" : true,
            "vouchers" : false,
            "finances" : {
                "transactions" : true,
                "salesBillings" : false,
                "paymentAccounts" : true
            },
            "statistics": false,
            "my-inbooma" : false,
            "tasks" : true,
            "filemanager" : true,
            "visual_inspections": false
        },
        "guide" : {
            "dashboard" : true,
            "reservations" : {
                "reservationsList" : true,
                "orders": true,
                "calendar": true
            },
            "reservationsList" : true,
            "orders": true,
            "contingents" : {
                "contingents" : false,
                "products" : false,
                "locations" : false,
                "facilities" : false,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : false
            },
            "resources" : false,
            "users" : {
                "users" : false,
                "staff" : false,
                "groupList": false,
                "messages": false
            },
            "appointments" : true,
            "vouchers" : false,
            "finances" : {
                "transactions" : false,
                "salesBillings" : false,
                "paymentAccounts" : false
            },
            "statistics": false,
            "my-inbooma" : false,
            "tasks" : true,
            "filemanager" : true,
            "visual_inspections": false
        },
        "garage-staff" : {
            "dashboard" : false,
            "reservations" : {
                "reservationsList" : true,
                "orders": true,
                "calendar": true
            },
            "contingents" : {
                "contingents" : true,
                "products" : false,
                "locations" : true,
                "facilities" : false,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : true
            },
            "resources" : true,
            "users" : {
                "users" : false,
                "staff" : false,
                "groupList": false,
                "messages": false
            },
            "appointments" : true,
            "vouchers" : false,
            "finances" : {
                "transactions" : false,
                "salesBillings" : false,
                "paymentAccounts" : false
            },
            "statistics": false,
            "my-inbooma" : false,
            "tasks" : true,
            "filemanager" : false,
            "visual_inspections": true
        },
        "user" : {
            "dashboard" : false,
            "reservations" : {
                "reservationsList" : false,
                "orders": true,
                "calendar": true
            },
            "contingents" : {
                "contingents" : false,
                "products" : false,
                "locations" : false,
                "facilities" : false,
                "pricetariffs" : false,
                "pricediscounts" : false,
                "check_in_periods" : false
            },
            "resources" : false,
            "users" : {
                "users" : false,
                "staff" : false,
                "groupList": false,
                "messages": false
            },
            "appointments" : false,
            "vouchers" : false,
            "finances" : {
                "transactions" : true,
                "salesBillings" : false,
                "paymentAccounts" : false
            },
            "statistics": false,
            "my-inbooma" : false,
            "tasks" : false,
            "filemanager" : false,
            "visual_inspections": false
        }
    },
    "6" : {
        "initial_view" : {
            "admin" : "appointments",
            "manager" : "appointments",
            "manager-location" : "appointments",
            "booking-manager" : "reservationsList",
            "mediator" : "appointments",
            "guide" : "reservationsList",
            "garage-staff" : "tasks",
            "user" : "orders"
        }
    },
    "13" : {
        "initial_view" : {
            "admin" : "appointments",
            "manager" : "appointments",
            "manager-location" : "appointments",
            "booking-manager" : "reservationsList",
            "mediator" : "appointments",
            "guide" : "reservationsList",
            "garage-staff" : "tasks",
            "user" : "orders"
        }
    },
    "19" : {
        "initial_view" : {
            "admin" : "reservationsList",
            "manager" : "reservationsList",
            "manager-location" : "reservationsList",
            "booking-manager" : "reservationsList",
            "mediator" : "reservationsList",
            "guide" : "reservationsList",
            "garage-staff" : "tasks",
            "user" : "orders"
        } 
    },
    "26" : {
        "initial_view": {
            "admin": "reservationsList",
            "manager": "reservationsList",
            "manager-location": "reservationsList",
            "booking-manager": "reservationsList",
            "mediator": "reservationsList",
            "guide": "reservationsList",
            "garage-staff": "tasks",
            "user": "orders"
        },
        "admin": {
            "dashboard": false,
            "settings": true,
            "reservations": {
                "reservationsList": true,
                "orders": true,
                "calendar": true
            },
            "reservationsList": true,
            "orders": true,
            "contingents": {
                "contingents": true,
                "products": true,
                "locations": true,
                "facilities": true,
                "pricetariffs": true,
                "pricediscounts": true,
                "check_in_periods": true,
                "abonnements": true
            },
            "resources": true,
            "users": {
                "users": true,
                "staff": true,
                "groupList": true,
                "messages": true,
                "deleteMessages": true
            },
            "appointments": false,
            "vouchers": true,
            "finances": {
                "transactions": true,
                "salesBillings": true,
                "paymentAccounts": true
            },
            "statistics": true,
            "my-inbooma": true,
            "tasks": true,
            "filemanager": true,
            "visual_inspections": true
        },
        "support": {
            "helpdesk": true,
            "dashboard": false,
            "settings": false,
            "reservations": {
                "reservationsList": false,
                "orders": false,
                "calendar": false
            },
            "reservationsList": false,
            "orders": false,
            "contingents": {
                "contingents": false,
                "products": false,
                "locations": false,
                "facilities": false,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": false
            },
            "resources": false,
            "users": {
                "users": false,
                "staff": false,
                "groupList": false,
                "messages": false,
                "deleteMessages": false
            },
            "appointments": false,
            "vouchers": false,
            "finances": {
                "transactions": false,
                "salesBillings": false,
                "paymentAccounts": false
            },
            "statistics": false,
            "my-inbooma": false,
            "tasks": false,
            "filemanager": false,
            "visual_inspections": false
        },
        "manager": {
            "dashboard": false,
            "settings": true,
            "reservations": {
                "reservationsList": true,
                "orders": true,
                "calendar": true
            },
            "reservationsList": true,
            "orders": true,
            "contingents": {
                "contingents": true,
                "products": true,
                "locations": true,
                "facilities": true,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": true,
                "abonnements": true
            },
            "resources": true,
            "users": {
                "users": true,
                "staff": true,
                "groupList": true,
                "messages": true,
                "deleteMessages": true
            },
            "appointments": false,
            "vouchers": true,
            "finances": {
                "transactions": true,
                "salesBillings": true,
                "paymentAccounts": false
            },
            "statistics": true,
            "my-inbooma": true,
            "tasks": true,
            "filemanager": true,
            "visual_inspections": true
        },
        "manager-location": {
            "dashboard": false,
            "orders": true,
            "reservationsList": true,
            "reservations": {
                "calendar": true,
                "reservationsList": true
            },
            "contingents": {
                "contingents": true,
                "products": true,
                "locations": true,
                "facilities": false,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": true
            },
            "resources": true,
            "users": {
                "users": true,
                "staff": false,
                "groupList": true,
                "messages": false
            },
            "appointments": true,
            "vouchers": false,
            "finances": {
                "transactions": true,
                "salesBillings": true,
                "paymentAccounts": false
            },
            "statistics": true,
            "my-inbooma": true,
            "tasks": true,
            "filemanager": true,
            "visual_inspections": false
        },
        "booking-manager": {
            "dashboard": false,
            "reservations": {
                "reservationsList": true,
                "orders": true,
                "calendar": true
            },
            "reservationsList": true,
            "orders": true,
            "contingents": {
                "contingents": false,
                "products": false,
                "locations": false,
                "facilities": false,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": true
            },
            "resources": true,
            "users": {
                "users": true,
                "staff": true,
                "groupList": false,
                "messages": false
            },
            "appointments": false,
            "vouchers": false,
            "finances": {
                "transactions": false,
                "salesBillings": true,
                "paymentAccounts": false
            },
            "statistics": true,
            "my-inbooma": true,
            "tasks": true,
            "filemanager": true,
            "visual_inspections": false
        },
        "mediator": {
            "dashboard": false,
            "reservations": {
                "reservationsList": true,
                "orders": true,
                "calendar": true
            },
            "reservationsList": true,
            "orders": true,
            "contingents": {
                "contingents": false,
                "products": false,
                "locations": false,
                "facilities": false,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": false
            },
            "resources": true,
            "users": {
                "users": true,
                "staff": false,
                "groupList": false,
                "messages": false
            },
            "appointments": true,
            "vouchers": false,
            "finances": {
                "transactions": true,
                "salesBillings": false,
                "paymentAccounts": true
            },
            "statistics": false,
            "my-inbooma": false,
            "tasks": true,
            "filemanager": true,
            "visual_inspections": false
        },
        "guide": {
            "dashboard": false,
            "reservations": {
                "reservationsList": true,
                "orders": true,
                "calendar": true
            },
            "reservationsList": true,
            "orders": true,
            "contingents": {
                "contingents": false,
                "products": false,
                "locations": false,
                "facilities": false,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": false
            },
            "resources": false,
            "users": {
                "users": false,
                "staff": false,
                "groupList": false,
                "messages": false
            },
            "appointments": true,
            "vouchers": false,
            "finances": {
                "transactions": false,
                "salesBillings": false,
                "paymentAccounts": false
            },
            "statistics": false,
            "my-inbooma": false,
            "tasks": true,
            "filemanager": true,
            "visual_inspections": false
        },
        "garage-staff": {
            "dashboard": false,
            "reservations": {
                "reservationsList": true,
                "orders": true,
                "calendar": true
            },
            "contingents": {
                "contingents": true,
                "products": false,
                "locations": true,
                "facilities": false,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": true
            },
            "resources": true,
            "users": {
                "users": false,
                "staff": false,
                "groupList": false,
                "messages": false
            },
            "appointments": true,
            "vouchers": false,
            "finances": {
                "transactions": false,
                "salesBillings": false,
                "paymentAccounts": false
            },
            "statistics": false,
            "my-inbooma": false,
            "tasks": true,
            "filemanager": false,
            "visual_inspections": true
        },
        "user": {
            "dashboard": false,
            "reservations": {
                "reservationsList": false,
                "orders": true,
                "calendar": true
            },
            "contingents": {
                "contingents": false,
                "products": false,
                "locations": false,
                "facilities": false,
                "pricetariffs": false,
                "pricediscounts": false,
                "check_in_periods": false
            },
            "resources": false,
            "users": {
                "users": false,
                "staff": false,
                "groupList": false,
                "messages": false
            },
            "appointments": false,
            "vouchers": false,
            "finances": {
                "transactions": true,
                "salesBillings": false,
                "paymentAccounts": false
            },
            "statistics": false,
            "my-inbooma": false,
            "tasks": false,
            "filemanager": false,
            "visual_inspections": false
        }
    }
}